import { type FC } from 'react';
import cn from 'classnames';

import { type LotteryRewardName } from '@/common/types/lottery';
import { selectCurrentInProgressLoteryData } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { prizeOf } from '../prizes';

import { OtherRewardItem } from './OtherRewardItem/OtherRewardItem';

interface OtherRewardsProps {
  className?: string;
}

const OtherRewards: FC<OtherRewardsProps> = ({ className }) => {
  const currentLottery = useAppSelector(selectCurrentInProgressLoteryData);
  // Places 4+ grouped by prize: "12 rewards — 5 T-Gem", "40 — 1 dice"…
  const rewardList = currentLottery
    ? Object.values(currentLottery.rewards)
        .slice(3)
        .map(prizeOf)
        .reduce<{ name: LotteryRewardName; reward: number; count: number }[]>(
          (groups, prize) => {
            if (!prize) return groups;

            const group = groups.find(
              (item) => item.name === prize.name && item.reward === prize.value,
            );

            if (group) {
              group.count += 1;
            } else {
              groups.push({ name: prize.name, reward: prize.value, count: 1 });
            }

            return groups;
          },
          [],
        )
    : undefined;

  return (
    <div
      className={cn(
        'w-full flex flex-wrap justify-center gap-[6px]',
        className,
      )}
    >
      {rewardList?.map((props, index) => (
        <OtherRewardItem key={index} {...props} />
      ))}
    </div>
  );
};

export { OtherRewards };
